import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import { queryClient } from './config/queryClient'
import { showForegroundNotifications } from './services/pushService'
import './styles/global.css'

// Started here rather than inside a component: it must survive every route change, and a
// message arriving while the tab is in front is the one case the service worker never
// sees. Fire-and-forget — it resolves to nothing when notifications were never allowed.
showForegroundNotifications()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
